import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';

// import auth from '../../functions/auth';

class AddOfficer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  HandleChange = e => {
    this.setState({
      [e.target.id]: e.target.value,
    });
    console.log(this.state);
  };
  handleSubmit = (e) => {
    e.preventDefault()
    console.log('Submitted')
    axios.post(
      'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
      {

        'action': 'createOfficer',
        'data': this.state,

      }
    ).then(res => {
      console.log(res);
      this.props.history.push('/admin')
    })
  }
  handleSubmitAuto =()=>{
    const data  = ['นายวินัย','ธรรมขจรจิต'
        ,'นายสมาน','เอี่ยมทอง'
        ,'นายบุณยกฤต','ไผทฉันท์'
        ,'นายโกวิทย์','ยั่งยืน'
        ,'นายสมพงษ์','เดชพิสุทธิธรรม'
        ,'นายภราดร','สาระวงศ์'
        ,'นายฤทธิศักดิ์','อินทราวิชกุล'
        ,'นายสุขสันต์','พรเรืองวงศ์'
        ,'นายบุญเลิศ','พงษ์ยิ้ม'
        ,'นายชุมพร','ตอทรัพย์ถาวร'
        ,'นายธวัชชัย','สายธนู'
        ,'นายอำพล','วีนะนาวิน'
        ,'นายวัธน','ผดุงเอี่ยม'
        ,'นายวิสูตร','เลิศไสว'
        ,'นายแสวง','มั่นคง'
        ,'นายธนกร','สัตยาพันธุ์'
        ,'นายภูษิต','ภูมิภาษิต'
        ,'นายสามารถ','ชาวอุทัย'
        ,'นายวัฒนา','เขียมทรัพย์'
        ,'นายณรงค์','แก้วศรี'
        ,'นายสมิทธิพงศ์','ประกอบพรกิจ'
        ,'นายวรินทร','อยู่สบาย'
        ,'นายศุภชัย','ทักษิณาวาริน'
        ,'นายชัยรัชต์','โชคเตชะสวัสดิ์'
        ,'นายรชานนท์','พรเรืองวงศ์'
        ,'นายพรหมเมศวร์','อ้นพร้อม'
        ,'นายสุเมธ','สภานุชาต'
        ,'นายชัยยงค์','ศุภศิริ'
        ,'นายภานุมาส','เกษประดิษฐ์'
        ,'นายพงศ์สนิท','จำเริญรักษ์'
        ,'นายพิสิทธิ์','พฤฒพันธ์'
        ,'นายชุติพนธ์','โชคเตชะสวัสดิ์'
        ,'นายชัยสิทธิ์','พงษ์ศาศวัต'
        ,'นายชลอ','เกษประดิษฐ์'
        ,'นายอนวิล','มุขศรีใส'
        ,'นายสุพีระพล','แก้วพลอย'
        ,'นายรัชพร','เสรี'
        ,'นายเริงฤทธิ์','อินทราวิชกุล'
        ,'นายศรัชม์ชาติ','จุฑามาศ'
        ,'นายธนากร','พุ่มปรีดา'
        ,'นายศักดิ์สิทธิ์','สุวิเศษศักดิ์'
        ,'นายพุทธา','ศรีศุภกฤติ'
        ,'นายทศพล','พงษ์ศาศวัต'
        ,'นายชาลี','เกษประดิษฐ์'
        ,'นายพีระศักดิ์','คำพิฑูรย์'
        ,'นายชานนท์','ศิริโสภณา'
        ,'นายทศพร','บุตรศรี'
        ,'นายณัฐพล','พงษ์ศาศวัต'
        ,'นายสกล','รอบคอบ'
        ,'นายประสิทธิ์','พันธ์พงษ์สานนท์'
        ,'นายจักรกฤษณ์','ศุภกิจมงคล']
    let i = 0 
    function run(i){
      axios.post(
        'https://us-central1-riceinspection-16b06.cloudfunctions.net/middleWare',
        {
         
          'action': 'createOfficer',
          'data' : {
            fName:data[i*2],
            lName:data[(i*2)+1],
            userName: `${i}`,
          },
          
        }
      ).then(res => {
        if(i != 51 ){
          i++
          run(i)  
        }else{
          
        }
      })  
    }
    run(i)
  }



  render() {
    return (
      <Container>
        {/* {this.handleSubmitAuto()} */}
        <form onSubmit={this.handleSubmit}>
          <Link to="AdminSys">back</Link>
          <h1 id="label1">Add Officer</h1>
          <label id="label">First name</label>
          <input type="text" id="fName" className="inputText" placeholder="First Name" onChange={this.HandleChange}></input>
          <label id="label">Last name</label>
          <input type="text" id="lName" className="inputText" placeholder="Last name" onChange={this.HandleChange}></input>
          <label id="label">Username</label>
          <input type="text" id="userName" className="inputText" placeholder="Username" onChange={this.HandleChange}></input>
          <Button variant="danger" id="addOffice" onClick={this.props.history.goBack}>cancel</Button>
          <Button variant="outline-success" id="addOffice" type="submit">Add</Button>
        </form>

      </Container>
    )
  }
}

export default AddOfficer;
